/**
 * Data layer for `real-time-dns-cname-propagation-without-48hr-wait`. Thin typed fetch wrappers over /api/v1/real-time-dns-cname-propagation-without-48hr-wait.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface RealTimeDnsCnamePropagationWithout48hrWaitRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListRealTimeDnsCnamePropagationWithout48hrWaitResponse {
	count: number;
	items: RealTimeDnsCnamePropagationWithout48hrWaitRow[];
}

export interface CreateRealTimeDnsCnamePropagationWithout48hrWaitBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/real-time-dns-cname-propagation-without-48hr-wait";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListRealTimeDnsCnamePropagationWithout48hrWaitResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListRealTimeDnsCnamePropagationWithout48hrWaitResponse>(res);
}

export async function create(body: CreateRealTimeDnsCnamePropagationWithout48hrWaitBody): Promise<RealTimeDnsCnamePropagationWithout48hrWaitRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<RealTimeDnsCnamePropagationWithout48hrWaitRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const realTimeDnsCnamePropagationWithout48hrWaitQueryKeys = {
	all: ["real-time-dns-cname-propagation-without-48hr-wait"] as const,
	list: () => [...realTimeDnsCnamePropagationWithout48hrWaitQueryKeys.all] as const,
	detail: (id: string) => [...realTimeDnsCnamePropagationWithout48hrWaitQueryKeys.all, id] as const,
};
